import axiosWithAuth from '@/utils/axiosWithAuth';

export type OffPlatformWeightedSlice = {
  code?: string | null;
  name?: string | null;
  weight: number;
};

export type OffPlatformAudience = {
  genders?: OffPlatformWeightedSlice[];
  ages?: OffPlatformWeightedSlice[];
  geoCountries?: OffPlatformWeightedSlice[];
  languages?: OffPlatformWeightedSlice[];
};

export type OffPlatformPost = {
  id: string;
  url: string;
  created?: string | null;
  text?: string | null;
  thumbnail?: string | null;
  likes?: number | null;
  comments?: number | null;
  views?: number | null;
  type?: string | null;
};

export type OffPlatformCreatorSnapshotIdentity = {
  provider: string;
  handle: string;
  profileUrl?: string | null;
  followerCount?: number | null;
  engagementRate?: number | null;
  views?: number | null;
  avgLikes?: number | null;
  avgComments?: number | null;
  avgViews?: number | null;
  engagements?: number | null;
  audience?: OffPlatformAudience;
  popularPosts?: OffPlatformPost[];
  recentPosts?: OffPlatformPost[];
};

export type OffPlatformCreatorSnapshot = {
  id: string;
  source: 'off_platform';
  displayName?: string | null;
  email: string;
  avatarUrl?: string | null;
  bio?: string | null;
  city?: string | null;
  region?: string | null;
  country?: string | null;
  gender?: string | null;
  ageGroup?: string | null;
  avgLikes?: number | null;
  avgComments?: number | null;
  avgViews?: number | null;
  engagements?: number | null;
  interests?: {name: string}[];
  identities: OffPlatformCreatorSnapshotIdentity[];
  audience?: OffPlatformAudience;
  popularPosts?: OffPlatformPost[];
  recentPosts?: OffPlatformPost[];
  inviteSuppressed?: boolean;
  campaignInvites?: {campaignId: string; campaignName: string}[];
};

const crmOffPlatformCreatorsFetchers = {
  get: async ({
    id,
    brandId,
  }: {
    id: string;
    brandId: string;
  }): Promise<OffPlatformCreatorSnapshot> => {
    const result = await axiosWithAuth.get<OffPlatformCreatorSnapshot>(
      `/crm/off_platform_creators/${id}`,
      {params: {brand_id: brandId}}
    );
    return result.data;
  },
};

export default crmOffPlatformCreatorsFetchers;
